import {
  addApplication,
  removeApplication,
  resetSecretKeyCommunication,
  resetMediaSecretKeyCommunication,
  setApplications,
  setBillingDetails,
  setDiscounts,
  setPaymentSources,
  setDefaultAccountError,
  setContracts,
  setCurrentApplication,
  setInvoices,
  setOrganizationDetails,
  setOrganizationCreated,
  setOrganizationId,
  setInvitedUserOrganizationId,
  setProfile,
  setSecretKeyCommunication,
  setMediaSecretKeyCommunication,
  setUsageApplication,
  setUsageApplicationSummary,
  setUsage,
  setUsageSummary,
  setUsers,
  setWebhooksEvents,
  setIntegrations,
  deleteIntegration,
  setPaymentSourcesError,
} from '../effects/organization';
import { handleEffects } from '../utils/store';

const initialState = {};

export default handleEffects(
  {
    [setOrganizationDetails]: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          ...action.payload,
          isCustomer: ['PAID', 'ENTERPRISE', 'UNLIMITED', 'MANUAL'].includes(
            action.payload.orgType,
          ),
        };
      }
      return {
        ...state,
      };
    },
    [setOrganizationCreated]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    [setApplications]: (state, action) => ({
      ...state,
      applications: {
        ...action.payload,
      },
    }),
    [addApplication]: (state, action) => ({
      ...state,
      applications: {
        ...state.applications,
        content: [...state.applications.content, action.payload],
      },
    }),
    [setBillingDetails]: (state, action) => ({
      ...state,
      billingSuccess: action.payload.billingSuccess,
      ...(action.payload.result && {
        ...action.payload.result,
      }),
    }),
    [setDiscounts]: (state, action) => ({
      ...state,
      discounts: action.payload,
    }),
    [setUsers]: (state, action) => ({
      ...state,
      users: action.payload.reverse(),
    }),
    [setInvoices]: (state, action) => ({
      ...state,
      invoices: action.payload,
    }),
    [setPaymentSources]: (state, action) => ({
      ...state,
      paymentSources: action.payload,
    }),
    [setPaymentSourcesError]: (state, action) => ({
      ...state,
      paymentSourcesError: action.payload,
    }),
    [setDefaultAccountError]: (state, action) => ({
      ...state,
      defaultAccountError: action.payload,
    }),
    [setContracts]: (state, action) => ({
      ...state,
      contracts: {
        ...action.payload,
      },
    }),
    [setUsageSummary]: (state, action) => ({
      ...state,
      usage: {
        summary: {
          ...action.payload,
        },
        ...state.usage,
      },
    }),
    [removeApplication]: (state, action) => ({
      ...state,
      applications: {
        ...state.applications,
        content: state.applications.content
          .filter((application) => application.id !== action.payload.appId)
          .map((application) => application),
      },
    }),
    [resetSecretKeyCommunication]: (state, action) => ({
      ...state,
      applications: {
        ...state.applications,
        content: state.applications?.content?.map((application) => {
          if (application.id.toString() === action.payload.appId) {
            return { ...application, appSecret: null };
          }
          return application;
        }),
      },
    }),
    [setSecretKeyCommunication]: (state, action) => ({
      ...state,
      applications: {
        ...state.applications,
        content:
          state.applications &&
          state.applications.content &&
          state.applications.content.map((application) => {
            if (application.id.toString() === action.payload.appId) {
              return { ...application, appSecret: action.payload.appSecret };
            }
            return application;
          }),
      },
    }),
    [resetMediaSecretKeyCommunication]: (state, action) => ({
      ...state,
      applications: {
        ...state.applications,
        content: state.applications.content.map((application) => {
          if (application.id.toString() === action.payload.appId) {
            return { ...application, mediaAppSecret: null };
          }
          return application;
        }),
      },
    }),
    [setMediaSecretKeyCommunication]: (state, action) => ({
      ...state,
      applications: {
        ...state.applications,
        content: state.applications.content.map((application) => {
          if (application.id.toString() === action.payload.appId) {
            return {
              ...application,
              mediaAppSecret: action.payload.mediaAppSecret,
            };
          }
          return application;
        }),
      },
    }),
    [setWebhooksEvents]: (state, action) => ({
      ...state,
      webhooksEvents: action.payload.events,
    }),
    [setUsageApplication]: (state, action) => ({
      ...state,
      applications: {
        ...state.applications,
        content: state.applications.content.map((application) => {
          if (application.id.toString() === action.payload.appId) {
            return { ...application, usageDays: action.payload.days };
          }
          return application;
        }),
      },
    }),
    [setUsageApplicationSummary]: (state, action) => ({
      ...state,
      applications: {
        ...state.applications,
        content: state.applications?.content?.map((application) => {
          const {
            payload: { appId, summary },
          } = action;
          if (application.id.toString() === appId.toString()) {
            return {
              ...application,
              usageSummary: {
                ...application.usageSummary,
                ...summary,
              },
            };
          }
          return application;
        }),
      },
    }),
    [setUsage]: (state, action) => ({
      ...state,
      usage: {
        ...state.usage,
        ...action.payload,
        filters: {
          ...state?.usage?.filters,
          ...action?.payload?.filters,
        },
      },
    }),
    [setProfile]: (state, action) => ({
      ...state,
      profile: {
        ...action.payload,
      },
    }),
    [setCurrentApplication]: (state, action) => ({
      ...state,
      currentApplicationId: action.payload,
    }),
    [setOrganizationId]: (_, action) => ({ ...action.payload }),
    [setInvitedUserOrganizationId]: (_, action) => ({ ...action.payload }),
    [setIntegrations]: (state, action) => ({
      ...state,
      integrations: {
        ...action.payload,
      },
    }),
    [deleteIntegration]: (state, action) => ({
      ...state,
      integrations: {
        ...state.integrations,
        content: state.integrations.content.filter(
          (integration) => integration.id !== action.payload.id,
        ),
      },
    }),
  },
  initialState,
);
